// Port of api/fuel/app/classes/insights/worth/valuations.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function worthFilter(filter) {
	return filter['valuations.expansions'] || filter.valuations || 'games'
}

export default Segment.extend({
	name: 'valuations',
	types: [Constants.TYPE_USER],
	insight: false,
	detail: ['valuations'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		var selected = worthFilter(filter || {})

		if (vars.band !== undefined) {
			var band = parseInt(vars.band, 10)
			var games = []
			var valuations = [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]
			var detailRaw = Util.queryFast(
				'SELECT g.game_id AS g, COALESCE(NULLIF(v.game_version_worth_value, 0), g.game_worth_value, 0) AS w' +
				' FROM (collection c JOIN game g ON c.game_id = g.game_id)' +
				' LEFT JOIN game_version v ON v.game_version_id = c.game_version_id' +
				' WHERE c.user_id = ' + owner.get_id() +
				' AND c.collection_own = 1' +
				(selected !== 'all' ? (' AND c.collection_expansion = ' + (selected === 'games' ? 0 : 1)) : '') +
				' AND g.game_worth_value > 0 ORDER BY g.game_sortname ASC'
			)

			for (var i = 0; i < detailRaw.length; i++) {
				var item = detailRaw[i]
				var segment = Math.ceil((parseFloat(item.w) || 0) / 8) - 1
				if (segment > 15) segment = 15
				if (segment < 0) segment = 0
				valuations[segment].push(item)
			}

			var bandItems = valuations[band] || []
			for (var j = 0; j < bandItems.length; j++) {
				var gameId = parseInt(bandItems[j].g, 10)
				this._references.games.push(gameId)
				games.push({
					id: gameId,
					worth: Math.round(parseFloat(bandItems[j].w) || 0)
				})
			}

			return {
				games: games
			}
		}

		var valuationsSummary = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
		var raw = Util.queryFast(
			'SELECT g.game_id AS g, COALESCE(NULLIF(v.game_version_worth_value, 0), g.game_worth_value, 0) AS w' +
			' FROM (collection c JOIN game g ON c.game_id = g.game_id)' +
			' LEFT JOIN game_version v ON v.game_version_id = c.game_version_id' +
			' WHERE c.user_id = ' + owner.get_id() +
			' AND c.collection_own = 1' +
			(selected !== 'all' ? (' AND c.collection_expansion = ' + (selected === 'games' ? 0 : 1)) : '') +
			' AND g.game_worth_value > 0'
		)

		for (var r = 0; r < raw.length; r++) {
			var worth = parseFloat(raw[r].w) || 0
			var segmentIndex = Math.ceil(worth / 8) - 1
			if (segmentIndex > 15) segmentIndex = 15
			if (segmentIndex < 0) segmentIndex = 0
			valuationsSummary[segmentIndex]++
		}

		return {
			valuations: valuationsSummary
		}
	}
})
